
import { supabase } from "@/integrations/supabase/client";
import { EmployeeFormData } from "@/components/admin/employees/types";
import { useToast } from "@/hooks/use-toast";

export const useEmployeeCreation = () => {
  const { toast } = useToast();

  const createEmployee = async (formData: EmployeeFormData) => {
    try {
      console.log("Creating employee with data:", formData);
      
      // Call edge function to create employee properly
      const { data, error } = await supabase.functions.invoke('create-employee', {
        body: {
          email: formData.email,
          password: formData.password || 'tempPassword123',
          first_name: formData.first_name,
          last_name: formData.last_name,
          phone: formData.phone || '',
          role: formData.role
        }
      });
      
      if (error) {
        console.error("Error from create-employee function:", error);
        throw error;
      }
      
      if (!data?.user) {
        console.error("No user data returned from create-employee function");
        throw new Error("No user data returned");
      }
      
      console.log("Employee created successfully:", data.user.id);
      console.log("Employee metadata:", data.user.user_metadata);
      
      // Explicitly verify profile data after creation
      const { data: verifyProfile, error: verifyError } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', data.user.id)
        .single();
        
      if (verifyError) {
        console.error("Error verifying profile:", verifyError);
      } else {
        console.log("Verified employee profile:", verifyProfile);
        console.log("Profile first_name:", verifyProfile.first_name);
        console.log("Profile last_name:", verifyProfile.last_name);
        console.log("Profile phone:", verifyProfile.phone);
      }

      return { success: true, user: data.user };
    } catch (error: any) {
      console.error("Error creating employee:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: error.message || "Failed to create employee",
      });
      return { success: false, error };
    }
  };

  return { createEmployee };
};
